module.exports = __webpack_public_path__ + "media/images/default-e572b3e5fd01c5fabb9c6209d48be4c6.jpg";